module.exports = __webpack_public_path__ + "img/collectHeart.90935031.png";